import React from "react";
import RecompensasTabela from "./Recompensas/RecompensasTabela";
import Card from "../../components/page/Card";
import { AppContext } from "../../contexts/AppContext";
import RecompensasCadastro from "./Recompensas/RecompensasCadastro";
import ErrorSwal from "../../components/Swal/errorSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import CommonSwal from "../../components/Swal/commonSwal";
import { Cores } from "../../constants/Cores";
import GestaoApiClient from "../../api/gestao";
import useApi from "../../hooks/useApi";
import RecompensasApiClient from "../../api/recompensas";
import { getPrimeiroDia, getUltimoDia } from "../../helpers/mesesHelper";
import Validation from "../../helpers/Validation";

function Recompensas() {
  const [recompensas, setRecompensas] = React.useState([]);
  const [values, setValues] = React.useState({});
  const [empresas, setEmpresas] = React.useState({});
  const { session } = React.useContext(AppContext);

  const { request: getEmpresas, data: empresasResponse } = useApi(
    GestaoApiClient.listEmpresas
  );
  const { request: getRecompensas, data: recompensasResponse } = useApi(
    RecompensasApiClient.listRecompensas
  );
  const postRecompensasApi = useApi(RecompensasApiClient.postRecompensas);
  const deleteRecompensaApi = useApi(RecompensasApiClient.deleteRecompensa);

  //Busca empresas ao renderizar tela
  React.useEffect(() => {
    getEmpresas();
  }, [getEmpresas]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (!empresasResponse) return;
    setEmpresas(empresasResponse);
  }, [empresasResponse]);

  //Busca recompensas ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getRecompensas(session.empresa.replace(/E/gi, ""));
  }, [getRecompensas, session.empresa]);

  //Define o retorno da api nos valores das linhas
  React.useEffect(() => {
    if (!recompensasResponse) return;
    setRecompensas(recompensasResponse.recompensas);
  }, [recompensasResponse]);

  const salvarIndicacao = () => {
    const formData = new FormData();
    formData.append("empresa_id", session?.empresa_uid);
    formData.append("indicada_id", values?.empresa);
    formData.append("data_inicio", getPrimeiroDia(values?.inicio));
    formData.append("data_fim", getUltimoDia(values?.fim));
    formData.append("valor", values?.valor);
    formData.append("tipo", values?.tipoRecompensa);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    OptionsSwal({
      title: "Tem certeza que deseja salvar esse item?",
      confirmButtonColor: Cores.buttons.azulConfirm,
      denyButtonColor: Cores.buttons.cinzaDeny,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await postRecompensasApi.request(
          session.empresa.replace(/E/gi, ""),
          formData
        );
        if (!response) return;
        CommonSwal({
          title: "Recompensa adicionada com sucesso!",
          icon: "success",
        });
        setValues({ valor: 0 });
        document.getElementById("valor").value = "";
        document.getElementById("inicio").value = "";
        document.getElementById("fim").value = "";
        getRecompensas(session.empresa.replace(/E/gi, ""));
      }
    });
  };

  const excluirRecompensa = (uid) => {
    OptionsSwal({
      title: "Tem certeza que deseja excluir essa recompensa?",
      confirmButtonColor: Cores.buttons.azulConfirm,
      denyButtonColor: Cores.buttons.cinzaDeny,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRecompensaApi.request(
          session.empresa.replace(/E/gi, ""),
          uid
        );
        if (!response) return;
        CommonSwal({
          title: "Recompensa excluída",
          icon: "success",
        });
        getRecompensas(session.empresa.replace(/E/gi, ""));
      }
    });
  };

  return (
    <>
      <Card>
        <RecompensasTabela
          recompensas={recompensas}
          excluirRecompensa={excluirRecompensa}
        />
      </Card>
      {parseInt(session.codigo) === 99 ? (
        <Card>
          <RecompensasCadastro
            valuesHook={{ values, setValues }}
            empresas={empresas}
            salvarIndicacao={salvarIndicacao}
          />
        </Card>
      ) : null}
    </>
  );
}

export default Recompensas;
